module.exports = __webpack_public_path__ + "img/video-4.38004ce4.png";